import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { refreshToken, isTokenExpired } from "./fileUploadSlice";

const baseUrl = process.env.REACT_APP_API_URL || "https://api.naturalremediesapp.com/api";

export const mediaApiService = createApi({
  reducerPath: "mediaApiService",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: async (headers) => {
      const token = localStorage.getItem("admin_token");
      const tokenExpiry = localStorage.getItem("admin_token_expires_at");

      if (token && isTokenExpired(tokenExpiry)) {
        try {
          const newToken = await refreshToken();
          headers.set("Authorization", `Bearer ${newToken}`);
        } catch (error) {
          window.location.href = "/admin/auth/sign-in";
          throw error;
        }
      } else if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  tagTypes: ["Media"],
  endpoints: (builder) => ({
    getMedia: builder.query({
      query: (searchParams = {}) => {
        const params = new URLSearchParams();
        if (searchParams.search) params.append("search", searchParams.search);
        if (searchParams.page) params.append("page", String(searchParams.page));
        if (searchParams.per_page) params.append("per_page", String(searchParams.per_page));
        const queryString = params.toString();
        return { url: `/media${queryString ? `?${queryString}` : ""}` };
      },
      providesTags: ["Media"],
    }),
    updateMediaTitle: builder.mutation({
      query: ({ filename, title }) => ({
        url: `/media/${encodeURIComponent(filename)}`,
        method: "PATCH",
        body: { title },
      }),
      invalidatesTags: ["Media"],
    }),
    deleteMedia: builder.mutation({
      query: (filename) => ({
        url: `/media/${encodeURIComponent(filename)}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Media"],
    }),
  }),
});

export const {
  useGetMediaQuery,
  useUpdateMediaTitleMutation,
  useDeleteMediaMutation,
} = mediaApiService;
